import { useEffect, useState, useContext } from 'react'
import Layout from "../../components/layout"
import { HeaderWrapper, ContentWrapper } from './style'
import Pagination from '../../components/pagination';
import { getTemplatesCategoriesApi, deleteTemplateCategoryApi } from '../../api'
import { AuthContext } from '../../context/auth';
import moment from 'moment/moment';
import DeleteTemplateModal from "../../components/modals/DeleteTemplateModal"
import AddTemplateModal from "../../components/modals/addTemplateModal"

const Index = () => {
  const { setIsLoading, setNotification, isLoading } = useContext(AuthContext)
  const [templatesCategories, setTemplatesCategories] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [deleteTemplateCategoryModal, setDeleteTemplateCategoryModal] = useState(false)
  const [openTemplateCategoryModal, setOpenTemplateCategoryModal] = useState(false)
  const [selectedTemplateCategory, setSelectedTemplateCategory] = useState(null)

  const fetchTemplatesCategories = () => {
    setIsLoading(true)
    getTemplatesCategoriesApi(10, currentPage * 10).then(res => {
      if (res && res.data) {
        setTemplatesCategories(res?.data)
        setIsLoading(false)
      }
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    fetchTemplatesCategories()
  }, [currentPage])


  const onDeleteTemplateCategory = () => {
    setIsLoading(true)
    deleteTemplateCategoryApi(selectedTemplateCategory?.id).then(() => {
      fetchTemplatesCategories()
      setDeleteTemplateCategoryModal(false)
      setOpenTemplateCategoryModal(false)
      setSelectedTemplateCategory(null)
      setIsLoading(false)
      setNotification({ type: 'success', message: 'Template Category deleted successfully' })
    }).catch(err => {
      setIsLoading(false)
      setNotification({ type: 'error', message: 'Something went wrong' })
    })
  }

  return (
    <Layout>
      <HeaderWrapper>
        <div className="header-title"><span className='sub-title'>Templates Category</span>{templatesCategories?.count}</div>
        <div className="header-search-container">
          <button className='btn' onClick={() => setOpenTemplateCategoryModal(true)}>Add New Templates Category</button>
        </div>
      </HeaderWrapper>
      <ContentWrapper>
        {templatesCategories && templatesCategories?.count > 0 ? <>
          <table className={"mainTable"}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Assigned Templates</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {templatesCategories?.templatesCategories?.map((data) => {
                return (
                  <tr
                    key={data?.id}
                  >
                    <td>
                      <strong>{data?.name}</strong>
                    </td>
                    <td className='td-col'>
                      {data?.templates?.map((item, index) => {
                        return <span className='template' key={index}>{item.name}</span>
                      })
                      }
                    </td>
                    <td>
                      {data?.created_at ? moment(data?.created_at).format('MMMM DD, YYYY, h:mm A') : "-"}
                    </td>
                    <td style={{ cursor: "pointer" }}>
                      <span style={{ display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => {
                          setSelectedTemplateCategory(data)
                          setOpenTemplateCategoryModal(true)
                        }}><i class="fal fa-pencil"></i></button>
                        <button style={{ fontSize: '16px', color: '#6c6a73' }}
                          onClick={() => {
                            setSelectedTemplateCategory(data)
                            setDeleteTemplateCategoryModal(true)
                          }}
                        ><i class="fal fa-trash-alt"></i></button>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {templatesCategories?.count / templatesCategories?.limit > 1 && <Pagination total={templatesCategories?.count / templatesCategories.limit} setCurrentPage={setCurrentPage} currentPage={currentPage} />}
        </>
          : <div className='no-orders'>
            <span className='icon'>
              <i class="far fa-boxes"></i>
            </span>
            <p>No Templates Category Found.</p>
          </div>
        }
      </ContentWrapper>
      {openTemplateCategoryModal && <AddTemplateModal setOpenTemplateModal={setOpenTemplateCategoryModal} selectedTemplate={selectedTemplateCategory} setSelectedTemplate={setSelectedTemplateCategory} fetchTemplates={fetchTemplatesCategories} setDeleteTemplateModal={setDeleteTemplateCategoryModal} type={'category'} />}
      {(deleteTemplateCategoryModal && selectedTemplateCategory) && <DeleteTemplateModal selectedTemplate={selectedTemplateCategory} setSelectedTemplate={setSelectedTemplateCategory} setDeleteTemplateModal={setDeleteTemplateCategoryModal} onDelete={onDeleteTemplateCategory} isLoading={isLoading} type={'category'} />}
    </Layout>
  )
}

export default Index